import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Container, Typography, styled } from "@mui/material";
import Footer from "../componentsPeopletech/Footer/Footer";

const PolicyContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
  backgroundColor: "#ffffff",
  maxWidth: "900px",
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "2.5rem",
  marginBottom: theme.spacing(4),
  textAlign: "center",
  color: "#000000",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "1.5rem",
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  color: "#1c2859",
}));

const SectionText = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  lineHeight: 1.8,
  color: "#414141",
  marginBottom: theme.spacing(2),
}));

const CookiePolicy = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "en";
  const baseUrl = "https://www.peoplefortech.com";

  return (
    <>
      <Helmet>
        <title>{t("cookiePolicy.pageTitle")}</title>
        <meta name="description" content={t("cookiePolicy.metaDescription")} />
        <link rel="canonical" href={`${baseUrl}/cookie-policy`} />
        <html lang={currentLang} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/cookie-policy`} />
        <meta property="og:title" content={t("cookiePolicy.ogTitle")} />
        <meta property="og:description" content={t("cookiePolicy.ogDescription")} />
      </Helmet>

      <PolicyContainer>
        <Title variant="h1">{t("cookiePolicy.heading")}</Title>

        <SectionText>{t("cookiePolicy.intro")}</SectionText>

        <SectionTitle variant="h2">{t("cookiePolicy.section1Title")}</SectionTitle>
        <SectionText>{t("cookiePolicy.section1Body")}</SectionText>

        <SectionTitle variant="h2">{t("cookiePolicy.section2Title")}</SectionTitle>
        <SectionText component="ul" sx={{ pl: 4 }}>
          <li>
            <strong>{t("cookiePolicy.section2EssentialStrong")}</strong>{" "}
            {t("cookiePolicy.section2EssentialText")}
          </li>
          <li>
            <strong>{t("cookiePolicy.section2AnalyticsStrong")}</strong>{" "}
            {t("cookiePolicy.section2AnalyticsText")}
          </li>
          <li>
            <strong>{t("cookiePolicy.section2MarketingStrong")}</strong>{" "}
            {t("cookiePolicy.section2MarketingText")}
          </li>
        </SectionText>

        <SectionTitle variant="h2">{t("cookiePolicy.section3Title")}</SectionTitle>
        <SectionText>{t("cookiePolicy.section3Body")}</SectionText>

        <SectionTitle variant="h2">{t("cookiePolicy.section4Title")}</SectionTitle>
        <SectionText>{t("cookiePolicy.section4Body")}</SectionText>

        <SectionTitle variant="h2">{t("cookiePolicy.section5Title")}</SectionTitle>
        <SectionText>{t("cookiePolicy.section5Body")}</SectionText>

        <SectionTitle variant="h2">{t("cookiePolicy.section6Title")}</SectionTitle>
        <SectionText>{t("cookiePolicy.section6Body")}</SectionText>
      </PolicyContainer>

      <Footer />
    </>
  );
};

export default CookiePolicy;
